export default "__VITE_ASSET__se4Y5NEW__"